<template lang="pug">
#app.layout.layout--form
  announcements-bar
  static-header-bar
  .page-form.with-cover
    .cover
    .content
      nuxt
  cookie-consent-alert
</template>

<script>
import AnnouncementsBar from '~/components/menus/AnnouncementsBar'
import StaticHeaderBar from '~/components/menus/StaticHeaderBar'
import CookieConsentAlert from '~/components/menus/CookieConsentAlert'

export default {
  name: 'FormLayout',

  components: {
    AnnouncementsBar,
    StaticHeaderBar,
    CookieConsentAlert
  }
}
</script>
